var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 7 .354.354-.354.353-.354-.353L6.5 7Zm6.354-5.646-6 6-.708-.708 6-6 .708.708Zm-6.708 6-6-6L.854.646l6 6-.708.708Z",
    fill: "#002FF1",
    stroke: "#002FF1",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlueIcon);
export default __webpack_public_path__ + "static/media/arrow-down-blue-icon.81345bdbea62d116b32c4aae8a326e28.svg";
export { ForwardRef as ReactComponent };